export const paddingZero = {
    paddingLeft: '0'
};

export const textToLeft = {
    textAlign: 'left'
};

export const leftMarginRadio = {
    marginLeft: '20px'
};

export const rightPaddingRadio = {
    paddingLeft: '20px'
};



// WEBPACK FOOTER //
// ./src/constants/loginStyle.js